export default "__VITE_ASSET__B3sEpx6i__"